import { IconMemberDiscount, IconOnePassDelivery, IconOnePassRibbon, IconOnePassTags } from "@catchoftheday/cg-components";
import { COPY_BENEFIT_EXCLUSIVE_DEALS, COPY_BENEFIT_FLYBUYS_POINTS, COPY_BENEFIT_FREE_DELIVERY, COPY_BENEFIT_MEMBER_PRICING } from "../../../consts";
export var BENEFITS = [{
  Icon: IconOnePassDelivery,
  text: COPY_BENEFIT_FREE_DELIVERY
}, {
  Icon: IconMemberDiscount,
  text: COPY_BENEFIT_MEMBER_PRICING
}, {
  Icon: IconOnePassTags,
  text: COPY_BENEFIT_EXCLUSIVE_DEALS
}, {
  Icon: IconOnePassRibbon,
  text: COPY_BENEFIT_FLYBUYS_POINTS
}];